const updates = [
  { date: '2026-08-01', title: '《长安十二时辰》全集上线，豆瓣高分古装悬疑剧一次性放出全部48集', tag: '新剧上线' },
  { date: '2026-07-31', title: '《黑暗荣耀》第二季完整版更新，宋慧乔复仇大戏全16集可在线观看', tag: '热门更新' },
  { date: '2026-07-30', title: '《狂飙》大结局已收录，张颂文演技封神之作全39集完整版上线', tag: '大结局' },
  { date: '2026-07-29', title: '《繁花》电视剧全集整理完毕，王家卫首部电视剧全30集高清上线', tag: '全集收录' },
  { date: '2026-07-28', title: '《漫长的季节》完整版更新，豆瓣9.4分国产悬疑神作全12集可看', tag: '高分推荐' },
  { date: '2026-07-27', title: '《琅琊榜》经典重温全集上线，胡歌巅峰之作全54集高清修复版', tag: '经典重温' },
  { date: '2026-07-26', title: '日剧《重启人生》全集收录，安藤樱主演高分治愈系全10集上线', tag: '日剧上线' },
  { date: '2026-07-25', title: '《庆余年》第二季大结局更新完毕，张若昀全36集完整版可在线观看', tag: '大结局' },
  { date: '2026-07-24', title: '韩剧《眼泪女王》全集收录，金秀贤金智媛主演全16集高清上线', tag: '韩剧上线' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              最新动态
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              每日同步最新电视剧全集、连续剧完整版与电视剧大结局上线信息
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300/60 -translate-x-1/2 hidden md:block"></div>

            <div className="flex flex-col gap-6">
              {updates.map((item, i) => (
                <div
                  key={i}
                  className={`relative flex flex-col md:flex-row gap-4 md:gap-0 ${
                    i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className="flex-1 hidden md:block"></div>

                  <div className="absolute left-4 md:left-1/2 top-6 w-3 h-3 rounded-full bg-primary-500 -translate-x-1/2 z-10 hidden md:block"></div>

                  <div className="flex-1">
                    <div className="bg-background-200/70 rounded-lg p-4 md:p-5 border border-background-300/30 hover:border-primary-500/30 transition-colors duration-200 cursor-pointer">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="text-foreground-500 text-xs whitespace-nowrap">{item.date}</span>
                        <span className="px-2 py-0.5 rounded-full bg-primary-500/15 text-primary-300 text-xs font-medium whitespace-nowrap">
                          {item.tag}
                        </span>
                      </div>
                      <h3 className="text-foreground-100 text-sm md:text-base leading-relaxed">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}